var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153.889,
    height: 153.888,
    viewBox: "0 0 153.889 153.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.074,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#d286ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#8a19ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#480971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974dc4",
    stopOpacity: 0.635
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(-334.248 -18.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18514",
    "data-name": "Path 18514",
    d: "M76.944,0A76.944,76.944,0,1,1,0,76.944,76.944,76.944,0,0,1,76.944,0Z",
    transform: "translate(334.248 18.248)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18514_-_Outline",
    "data-name": "Path 18514 - Outline",
    d: "M76.944,5.843A71.1,71.1,0,0,0,26.668,127.22,71.1,71.1,0,1,0,127.22,26.668,70.636,70.636,0,0,0,76.944,5.843m0-5.843A76.944,76.944,0,1,1,0,76.944,76.944,76.944,0,0,1,76.944,0Z",
    transform: "translate(334.248 18.248)",
    fill: "#ffd055"
  }), /*#__PURE__*/React.createElement("g", {
    id: "transfer",
    transform: "translate(370.284 64.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12016",
    "data-name": "Group 12016",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19072",
    "data-name": "Path 19072",
    d: "M80.2,72.307,59.934,52.046a2.894,2.894,0,0,0-4.941,2.047v8.683H34.732a2.895,2.895,0,0,0,0,5.789H57.888a2.9,2.9,0,0,0,2.894-2.895V61.079L74.056,74.353,60.782,87.627V83.036a2.894,2.894,0,0,0-2.894-2.895H26.049V71.459a2.894,2.894,0,0,0-4.941-2.046L.847,89.673a2.894,2.894,0,0,0,0,4.093l20.261,20.261a2.894,2.894,0,0,0,2.046.848,2.857,2.857,0,0,0,1.108-.22,2.894,2.894,0,0,0,1.786-2.674V103.3H46.31a2.894,2.894,0,1,0,0-5.789H23.155A2.894,2.894,0,0,0,20.26,100.4v4.591L6.986,91.72,20.26,78.446v4.591a2.894,2.894,0,0,0,2.894,2.895H54.993v8.683a2.894,2.894,0,0,0,4.941,2.046L80.2,76.4A2.9,2.9,0,0,0,80.2,72.307Z",
    transform: "translate(0.388 -50.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19072_-_Outline",
    "data-name": "Path 19072 - Outline",
    d: "M58.176,51.1h0a3.262,3.262,0,0,1,2.322.961L80.759,72.321a3.288,3.288,0,0,1,0,4.643L60.5,97.226A3.284,3.284,0,0,1,54.892,94.9V86.61H23.443a3.288,3.288,0,0,1-3.284-3.284v-3.65L7.826,92.009l12.334,12.334v-3.65a3.288,3.288,0,0,1,3.284-3.284H46.6a3.284,3.284,0,1,1,0,6.568H26.727v8.294A3.274,3.274,0,0,1,24.7,115.3a3.229,3.229,0,0,1-1.249.25,3.268,3.268,0,0,1-2.331-.962L.86,94.331a3.288,3.288,0,0,1,0-4.644L21.121,69.426a3.284,3.284,0,0,1,5.606,2.322v8.294H58.176a3.288,3.288,0,0,1,3.284,3.284v3.65L73.794,74.643,61.46,62.309v3.65a3.288,3.288,0,0,1-3.284,3.284H35.021a3.284,3.284,0,0,1,0-6.568H54.892V54.382A3.284,3.284,0,0,1,58.176,51.1Zm0,46.31a2.489,2.489,0,0,0,1.771-.733L80.208,76.414a2.508,2.508,0,0,0,0-3.542L59.947,52.611a2.488,2.488,0,0,0-1.771-.733h0a2.5,2.5,0,0,0-2.5,2.5v9.073H35.021a2.5,2.5,0,1,0,0,5.01H58.176a2.508,2.508,0,0,0,2.5-2.5V60.428L74.9,74.643,60.681,88.857V83.326a2.508,2.508,0,0,0-2.5-2.5H25.948V71.748a2.5,2.5,0,0,0-4.276-1.771L1.411,90.238a2.508,2.508,0,0,0,0,3.542l20.261,20.261a2.5,2.5,0,0,0,4.276-1.771V103.2H46.6a2.5,2.5,0,1,0,0-5.01H23.443a2.508,2.508,0,0,0-2.5,2.5v5.531L6.724,92.009,20.938,77.795v5.531a2.508,2.508,0,0,0,2.5,2.5H55.671V94.9a2.5,2.5,0,0,0,2.505,2.5Z",
    transform: "translate(0.1 -51.098)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralConvert);
export default __webpack_public_path__ + "static/media/general-convert.79424f89102f980f18acbbe19228d5c1.svg";
export { ForwardRef as ReactComponent };